import {
  FC,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import { BookContext } from "../contexts/BookContext";

export const DashboardProgressBar: FC = () => {
  const { t } = useTranslation();
  const bookContext = useContext(BookContext);

  const questions = bookContext.questions;
  const answers = bookContext.answers;

  const [renderKey, setRenderKey] = useState(100);

  useEffect(() => {
    setRenderKey((prevKey) => prevKey + 1);
  }, [questions, answers]);

  // Ratio Methods ========================================
  const calculateTotalRatio = useCallback(() => {
    const questions_ids = questions.map((question) => question.id);
    const filteredAnswers = answers.filter((answer) =>
      questions_ids.includes(answer.question_id)
    );
    const completedAnswers = filteredAnswers.filter(
      (answer) => answer.completed
    );
    return {
      completed: completedAnswers.length,
      on: questions_ids.length,
    };
  }, [questions, answers]);

  const totalRatio = useMemo(
    () => calculateTotalRatio(),
    [calculateTotalRatio, questions, answers]
  );

  return (
    <div
      key={renderKey}
      className="bg-white flex flex-col justify-between shadow-md rounded px-4 sm:px-6 lg:px-10 py-4"
    >
      <p className="text-slate-700 text-xl sm:text-2xl font-bold">
        {t("dashboard.dashboard")}
      </p>
      <p className="text-sm sm:text-base">
        <b>
          {t("dashboard.completed_questions")} : {totalRatio.completed}{" "}
          {t("dashboard.on")} {totalRatio.on}
        </b>
      </p>
      <div>
        <div aria-hidden="true" className="mt-6">
          <div className="overflow-hidden rounded-full bg-gray-200">
            <div
              style={{
                width: `${(totalRatio.completed / totalRatio.on) * 100}%`,
              }}
              className="h-2 rounded-full bg-delicate-800"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
